import { useEffect, useState } from "react";
import EntitiesTable from "../tables/EntitiesTable";
import EntityModal from "../modals/EntityModal";
import { ErrorBoundary } from "react-error-boundary";  // Add this import

import {
  listEntities,
  createEntity,
  updateEntity,
  deleteEntity,
} from "../api/entity";

function ErrorFallback({error}) {
    return (
      <div className="p-4 bg-red-50 border border-red-400 rounded">
        <h2 className="text-lg font-bold text-red-800">Something went wrong:</h2>
        <pre className="text-red-600">{error.message}</pre>
      </div>
    )
  }
export default function Entities() {
  console.log("⚙️ Entities component loaded");
  const [entities, setEntities] = useState([]);
  const [modal, setModal] = useState({ open: false, initial: null });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const handleSave = async (data) => {
    if (!data) {
      setModal({ open: false, initial: null });
      return;
    }

    setLoading(true);
    try {
      if (modal.initial) {
        await updateEntity(modal.initial.id, data);
      } else {
        await createEntity(data);
      }
      await refresh();
      setModal({ open: false, initial: null });
    } catch (err) {
      console.error("❌ Save failed:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const refresh = async () => {
    console.log("🔄 Refreshing entities...");
    setLoading(true);
    try {
      console.log("📡 Calling listEntities API...");
      const data = await listEntities();
      console.log("📦 API Response:", data);  // Log the API response
      
      if (!data) {
        console.warn("⚠️ No data received from API");
        setError("No data received from API");
        return;
      }
      
      setEntities(data);
      console.log("✅ Entities updated:", data.length, "items");
      setError(null);
    } catch (err) {
      console.error("❌ Error in refresh:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log("⚡ Component mounted, starting initial load");
    refresh();
    return () => console.log("💤 Component unmounted");
  }, []);

  console.log("🎨 Rendering with state:", { 
    loading, 
    error, 
    entityCount: entities?.length 
  });

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <div className="p-6 max-w-4xl mx-auto">
        <pre className="text-sm text-gray-500 mb-4">
          Debug State: {JSON.stringify({ loading, error, entityCount: entities?.length }, null, 2)}
        </pre>
        
        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
            {error}
          </div>
        )}
        
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-xl font-bold">Entities</h1>
          <button
            className="bg-blue-600 text-white px-4 py-2 rounded"
            onClick={() => setModal({ open: true, initial: null })}
          >
            + New
          </button>
        </div>

        {loading ? (
          <div className="text-center py-4">Loading entities...</div>
        ) : (
          <EntitiesTable
            entities={entities}
            onEdit={(e) => setModal({ open: true, initial: e })}
            onDelete={async (id) => { 
              try {
                console.log("🗑️ Deleting entity:", id);
                await deleteEntity(id); 
                await refresh(); 
              } catch (err) {
                console.error("❌ Delete failed:", err);
                setError(err.message);
              }
            }}
          />
        )}

        <EntityModal
          open={modal.open}
          initial={modal.initial}
          onClose={handleSave}
        />
      </div>
    </ErrorBoundary>
  );
}